import { Grid } from "@mui/material";
import CadastralDataFormSection from "./CadastralDataFormSection";
import DocumentsDataFormSection from "./DocumentsDataFormSection";
import ValidationProjectSection from "./validations-project/ValidationProjectSeption";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
const DocumentationStep = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MxFormSubTitle
          label="Agregar los documentos de la propiedad"
          isRequired={true}
        />
      </Grid>
      <Grid item xs={12}>
        <CadastralDataFormSection />
      </Grid>
      <Grid item xs={12}>
        <DocumentsDataFormSection />
      </Grid>
      <Grid item xs={12}>
        <ValidationProjectSection />
      </Grid>
    </Grid>
  );
};

export default DocumentationStep;
